import {Component} from '@angular/core';
import {BlockBaseComponent} from "../block-base/block-base.component";
import {StoreSelectorsService} from "../../../../services";
import {MatDialog} from "@angular/material/dialog";
import {TranslocoService} from "@ngneat/transloco";
import {actionUpdateEventsStrings} from "../../../../store/actions/user.actions";
import {IDialogGetAsset} from "../../../../components/dialog-get-asset/dialog-get-asset.component";
import {SceneMimeTypes} from "../mime-constants";
import {DialogEventsExplorerComponent} from "../../../events/dialog-events-explorer/dialog-events-explorer.component";
import {take} from "rxjs/operators";
import {IEventBlock} from "../../../../interfaces";

@Component({
    selector: 'app-block-data-provider',
    templateUrl: './block-data-provider.component.html',
    styleUrls: ['./block-data-provider.component.scss']
})
export class BlockDataProviderComponent extends BlockBaseComponent {
    eventParams = [];
    assignedEventParam;
    sourceType;

    constructor(private translocoService: TranslocoService, public override storeSelector: StoreSelectorsService, public override dialog: MatDialog) {
        super(storeSelector, dialog);
    }

    override submit(formValues) {
        return super.submit(formValues);
    }

    override componentInit() {
        super.componentInit();
        this.assignedEventParam = this.sceneItem.Data[0]?.DataProvider?.[0]?.$.eventName;
    }

    override componentStoreUpdates() {
        super.componentStoreUpdates();
        super.initApplyStoreToDynamic(true);
    }

    override initRegisterDynamic() {
        this.updateUIConfig(this.sceneItem.Data[0]?.DataProvider?.[0]?.$.source);
    }

    updateUIConfig(source) {
        this.sourceType = source;
        this.uiConfigInit = [
            {
                type: "input",
                value: '',
                label: this.translocoService.translate('general.eventName', {}, this.translocoService.getActiveLang()),
                inputType: "text",
                textSideButton: {
                    icon: 'notification_add',
                    callBackSideButton: (e, value) => {
                        e.preventDefault();
                        e.stopImmediatePropagation();
                        this.openEventsExplorerDialog('eventName', value);
                    }
                },
                // observable: this.storeSelector.getEventsCombined(),
                callBackValue: (item, direction) => this.dispatchEventsAll(),
                name: "eventName",
                storePath: `Data[0].DataProvider[0].$.eventName`
            },
            {
                type: "select",
                label: this.translocoService.translate('general.source', {}, this.translocoService.getActiveLang()),
                name: "source",
                value: "cloud",
                callBackEvent: (event) => this.changeSource(event),
                detectChange: true,
                options: ["cloud", "drive", "runtime", "external", "ifttt", "stringify"],
                storePath: `Data[0].DataProvider[0].$.source`
            },
            {
                type: "input",
                value: '',
                label: this.translocoService.translate('general.resultEventName2', {}, this.translocoService.getActiveLang()),
                inputType: "text",
                textSideButton: {
                    icon: 'notification_add',
                    callBackSideButton: (e, value) => {
                        e.preventDefault();
                        e.stopImmediatePropagation();
                        this.openEventsExplorerDialog('resultEventName', value);
                    }
                },
                // observable: this.storeSelector.getEventsCombined(),
                callBackValue: (item, direction) => this.dispatchEventsAll(),
                name: "resultEventName",
                storePath: `Data[0].DataProvider[0].$.resultEventName`,
                hideMe: ["cloud", "drive"].indexOf(source) == -1
            },
            {
                type: "input",
                value: '',
                label: this.translocoService.translate('general.resultEventParam', {}, this.translocoService.getActiveLang()),
                inputType: "text",
                name: "resultEventParam",
                storePath: `Data[0].DataProvider[0].$.resultEventParam`,
                hideMe: ["cloud", "drive"].indexOf(source) == -1
            },
            {
                type: "input",
                value: '',
                label: this.translocoService.translate('general.link', {}, this.translocoService.getActiveLang()),
                inputType: "text",
                name: "url",
                storePath: `Data[0].DataProvider[0].$.url`,
                hideMe: ["external", "ifttt", "stringify"].indexOf(source) == -1
            },
            {
                type: "input",
                value: '',
                label: this.translocoService.translate('general.itemsPath', {}, this.translocoService.getActiveLang()),
                inputType: "text",
                name: "itemsPath",
                storePath: `Data[0].DataProvider[0].$.itemsPath`
            },
            // {
            //     type: "input",
            //     value: '',
            //     label: this.translocoService.translate('general.metaData', {}, this.translocoService.getActiveLang()),
            //     inputType: "text",
            //     name: "metaData",
            //     storePath: `Data[0].DataProvider[0].$.metaData`,
            //     hideMe: ["external", "ifttt", "stringify"].indexOf(source) == -1
            // },
        ];
    }

    // onChangeEventParam(value) {
    //     let key = 'eventName';
    //     let storePath = 'Data["0"].DataProvider["0"].$';

    //     const block = DataProviderBlocks.find((b) => compareIds(this.sceneItem.$.player, b.id));

    //     switch (block.id) {
    //         case this.blockLabelRecords.JSON_VIEWER.id: {
    //         }
    //         case this.blockLabelRecords.JSON_PLAYER.id: {
    //         }
    //         case this.blockLabelRecords.STOCKS.id: {
    //         }
    //         default: {
    //             break;
    //         }
    //     }

    //     this.dispatchSceneItemChanges({
    //         sceneId: this.sceneId,
    //         sceneItemId: this.sceneItem.$.id,
    //         values: [{
    //             key,
    //             value,
    //             storePath
    //         }]
    //     });
    // }

    changeSource(item) {
        if (!item) return;
        this.updateUIConfig(item.source);
    }

    openEventsExplorerDialog(payload, value) {
        const data: IEventBlock = {
            eventName: value.name,
            eventBlockId: this.sceneItemId,
            blockName: this.sceneItem.$.label,
            eventSceneId: this.sceneId,
            eventType: '',
            sceneName: ''
        };
        const dialogRefVal = this.dialog.open(DialogEventsExplorerComponent, {
            width: '70%',
            data
        });
        this.cod(
            dialogRefVal.afterClosed()
                .pipe(take(1))
                .subscribe((result: IEventBlock) => {
                    if (!result) return;
                    this.setFormValue(result.payload.eventName, result.eventName);
                    this.submit(this.form.value);
                })
        );
    }

    dispatchEventsAll() {
        const eventsAll = [];
        if (this.sceneItem.Data[0]?.DataProvider?.[0]?.$?.resultEventName) {
            eventsAll.push(this.sceneItem.Data[0].DataProvider[0].$.resultEventName);
        }

        if (this.sceneItem.Data[0]?.DataProvider?.[0]?.$?.eventName) {
            eventsAll.push(this.sceneItem.Data[0].DataProvider[0].$.eventName);
        }

        if (eventsAll.length > 0) {
            this.storeSelector.dispatch(actionUpdateEventsStrings({eventsStrings: eventsAll}));
        }
    }
}
